import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { PartesService } from '../../services/partes.services';

/**
 * Generated class for the FincasDetallePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-fincas-detalle',
  templateUrl: 'fincas-detalle.html',
})
export class FincasDetallePage {
  item = {idFinca : null, idParcela : null, idProducto : null, Nombre : null, idEmpresa : null};
  constructor(public navCtrl: NavController, public navParams: NavParams,public alertCtrl: AlertController,public partesService : PartesService) {
    if(navParams.data.item != 0){ 
      this.item = navParams.data.item;
    }    
  }

  //Añadir Finca
  addFinca(){
    this.partesService.addFinca(this.item);
    this.navCtrl.pop();
  } 

  //Borrar Finca
  deleteFinca(){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar esta Finca?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
               this.partesService.deleteFinca(this.item);
               this.navCtrl.pop();
           }
        }
      ]
    });
    alert.present();
  } 


  ionViewDidLoad() {
    console.log('ionViewDidLoad FincasDetallePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/fincas-detalle/fincas-detalle.ts